import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 313B60B3-A740-4F5B-A63E-A5772C20AC0D
 * name minus-circle-multiple-outline
 * version: 2.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/minus-circle-multiple-outline.svg
 * tags
 * - Form 
 */
export const MinusCircleMultipleOutlineIcon = createSvgIcon(<><path d="M11 11V13H19V11H11M2 12C2 9.21 3.64 6.8 6 5.68V3.5C2.5 4.76 0 8.09 0 12S2.5 19.24 6 20.5V18.32C3.64 17.2 2 14.79 2 12M15 3C10.04 3 6 7.04 6 12S10.04 21 15 21 24 16.96 24 12 19.96 3 15 3M15 19C11.14 19 8 15.86 8 12S11.14 5 15 5 22 8.14 22 12 18.86 19 15 19Z" /></>, 'MinusCircleMultipleOutlineIcon');
export default MinusCircleMultipleOutlineIcon